<div class="loading-shade" *ngIf="processing"></div>

<div class="confirm-dialog-card">
    <nb-card>
        <nb-card-body *ngIf="!newuser">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-md-12">
                        <span class="title-text center">Add Users</span>
                        <span style="float:right">
                            <a [routerLink]="" (click)="onClose()" class="button-link"><nb-icon icon="close"></nb-icon></a>
                        </span>
                    </div>
                </div>
                
                <div class="row mb-2">
                    <div class="col-md-12 context-text">
                        Select and add users from the search results or create a new user.
                    </div>
                </div> 

                <div class="row mb-2">
                    <div class="col-md-12 info-text" style="font-size:13px;font-weight:600">
                        Search Results
                    </div>
                </div> 
                
                <div class="row mb-2">
                    <div class="col-md-12">
                        <app-select-users-list *ngIf="userSelectionList.length > 0" [rows]="userSelectionList"></app-select-users-list>
                    </div>
                </div>
                
                <div class="row mb-5">
                    <div class="col-md-12 center r-top">
                        <button nbButton size="small" status="primary" (click)="onSendSelection()" [disabled]="onNoSelections()">ADD SELECTED USERS</button>
                        <button class="ml-2" nbButton size="small" status="primary" (click)="onCreateNew()">+ NEW USER</button>
                        <button class="ml-2" nbButton size="small" status="primary" appearance="ghost" (click)="onClose()">Cancel</button>
                    </div>
                </div>
                
            </div>
        </nb-card-body>
        
        <nb-card-body *ngIf="newuser">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-md-12">
                        <span class="title-text center">Create New User</span>
                        <span style="float:right">
                            <a [routerLink]="" (click)="onClose()" class="button-link"><nb-icon icon="close"></nb-icon></a>
                        </span>
                    </div>
                </div>
                
                <div class="row mb-2">
                    <div class="col-md-12 content-text">
                        Once created, the user will need to login and reset their password.
                    </div>
                </div> 

                <form #f="ngForm">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="auction-label-text">FIRST NAME *</div>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-6">
                            <div class="form-control-group">
                                <input type="text"
                                       nbInput
                                       fullWidth
                                       id="firstname"
                                       name="firstname"
                                       placeholder="Type your first name"
                                       [(ngModel)]="firstname"
                                       [ngClass]="{'inputError':!firstnameentry.valid && firstnameentry.touched}"
                                       #firstnameentry="ngModel"
                                       required>
                                <div class="errorText" *ngIf="!firstnameentry.valid && firstnameentry.touched">Please provide first name.</div>
                            </div> <!-- form-control-group -->
                        </div> <!-- col-md-6 -->
                        <div class="col"></div>
                    </div> <!-- row -->
                    
                    <div class="row">
                        <div class="col-md-12">
                            <div class="auction-label-text">LAST NAME *</div>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-6">
                            <div class="form-control-group">
                                <input type="text"
                                       nbInput
                                       fullWidth
                                       id="lastname"
                                       name="lastname"
                                       placeholder="Type your last name"
                                       [(ngModel)]="lastname"
                                       [ngClass]="{'inputError':!lastnameentry.valid && lastnameentry.touched}"
                                       #lastnameentry="ngModel"
                                       required>
                                <div class="errorText" *ngIf="!lastnameentry.valid && lastnameentry.touched">Please provide last name.</div>
                            </div> <!-- form-control-group -->
                        </div> <!-- col-md-6 -->
                        <div class="col"></div>
                    </div> <!-- row -->
            
                    <div class="row">
                        <div class="col-md-12">
                            <div class="auction-label-text">EMAIL ADDRESS *</div>
                        </div>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-6">
                            <div class="form-control-group">
                                <input type="email"
                                       fullWidth
                                       nbInput
                                       id="email"
                                       name="email"
                                       placeholder="Type your email address"
                                       #emailentry="ngModel"
                                       [(ngModel)]="email"
                                       [ngClass]="{'inputError':!validEmail() && emailentry.touched}"
                                       required email>
                                <div class="errorText" *ngIf="!validEmail() && emailentry.touched">Please provide a valid email address.</div>
                            </div>
                        </div> <!-- col-md-6 -->
                        <div class="col"></div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-12">
                            <div class="auction-label-text">PHONE NUMBER *</div>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-6">
                            <div class="form-control-group">
                                <input mask="(000) 000-0000"
                                       [dropSpecialCharacters]="false"
                                       type="text"
                                       nbInput
                                       fullWidth
                                       id="phone"
                                       name="phone"
                                       placeholder="Type your phone number"
                                       #phoneentry="ngModel"
                                       [ngClass]="{'inputError':!validPhone() && phoneentry.touched}"
                                       maxlength="14"
                                       [(ngModel)]="phone">
                                <div class="errorText" *ngIf="!validPhone() && phoneentry.touched">Please enter a valid phone number.</div>
                            </div> <!-- form-control-group -->
                        </div> <!-- col-md-6 -->
                        <div class="col"></div>
                    </div> <!-- row -->
                    
                    <div class="row mb-2">
                        <div class="col-md-12">
                            <button [nbSpinner]="processing" nbButton (click)="onConfirmCreateNew()" status="primary" [disabled]="!requiredFields()">+ CREATE USER</button>                                
                            <button class="ml-2" nbButton size="small" status="primary" appearance="ghost" (click)="onCancelCreateNew()">Cancel</button>
                        </div>
                    </div>
                    
                    <div class="row mb-2" *ngIf="errorMsg.length > 0">
                        <div class="col-md-12">
                            <div><span class="errorText">{{errorMsg}}</span></div>
                        </div>
                    </div>

                </form> <!-- create user form -->  
            </div> <!-- container-fluid -->
        </nb-card-body>
        
    </nb-card>
</div>
